<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '580px' }"
    header="Novo Folder"
    :modal="true"
    @hide="hideDialog"
  >
    <div class="p-fluid formgrid grid">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <label for="path">Diretório Principal</label>
          <InputText id="path" v-model="folder.project.path" disabled />
        </div>
        <div class="field col-12 md:col-6">
          <label for="subDirectory">Sub-Diretório</label>
          <InputText
            id="subDirectory"
            v-model="v$.folder.subDirectory.$model"
            placeholder="Informe o nome do sub-diretório"
            :class="{
              'p-invalid': submitted && v$.folder.subDirectory.$invalid,
            }"
          />
          <small
            class="p-error"
            v-if="submitted && v$.folder.subDirectory.$invalid"
            >Campo obrigatório. Permitido somente [a-z] e [-].</small
          >
        </div>
        <div class="field col-12 md:col-6">
          <label for="description">Descrição Sub-Diretório</label>
          <InputText
            id="description"
            v-model="v$.folder.description.$model"
            placeholder="Informe a descrição do sub-diretório"
            :class="{
              'p-invalid': submitted && v$.folder.description.$invalid,
            }"
          />
          <small
            class="p-error"
            v-if="submitted && v$.folder.description.$invalid"
            >Campo obrigatório.
          </small>
        </div>
      </div>
    </div>
    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.folder.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Folder from "../../../models/folder";
import Project from "../../../models/project";

//Services
import FolderService from "../../../service/folder/folder_service";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["selected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      submitted: false,
      folder: new Folder(),
      folderService: new FolderService(),
      project: new Project(),
    };
  },
  validations() {
    return {
      folder: new Folder().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.folder.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.folder.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        if (!this.folder.id) {
          this.create();
        } else {
          this.update();
        }
      } else {
        return;
      }
    },
    create() {
      this.folderService
        .create(this.folder)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.folderService
        .update(this.folder)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.folder = new Folder();
      this.submitted = false;
      this.visibleDialog = false;
    },
    getData() {
      this.folder = this.selected;
    },
  },
};
</script>
<style scoped></style>
